import { PermissionRequestEffects } from './permission-request/permission-request.effects';
import { PorfileEffect } from '@app-core/store/effects/profile/profile.effects';
import { SharedEffects } from '@app-core/store/effects/shared/shared.effects';

export const EffectsArray: any[] = [
  PorfileEffect,
  SharedEffects,
  PermissionRequestEffects,
];
